import { useState } from 'react';
import TranslationDropdown from 'components/language-menu/TranslationDropdown';
import { useToggle } from 'hooks/useToggle';
import { Menu24 } from '@carbon/icons-react';
import { LoginSignupButtons } from './login-signup-buttons/LoginSignupButtons';
import { useResponsiveRender } from 'hooks/useResponsiveRender';
import ItemMenu from '../ItemMenu/ItemMenu';
import ModalLogalSignUp from 'components/navigation/ModalLoginSignUp/ModalLogalSignUp';
import { useClickOutside } from 'hooks/useClickOutside';
// styles
import styles from './language-buttons.module.scss';

const NologgedLanguageButtons = ({ routesNav, isLangAvailable = true }) => {
  const { renderMobile } = useResponsiveRender({ breakpoint: 767 });

  const [showLogInModal, onToggleLogInModal] = useToggle(false);
  const [showMobileMenu, onToggleMobileMenu] = useToggle(false);
  const [isLogin, setIsLogin] = useState(true);

  const domRef = useClickOutside(() => {
    if (showMobileMenu) onToggleMobileMenu();
  });

  const showModalLogin = () => {
    onToggleLogInModal();
    setIsLogin(true);
  };
  const showModalSignUp = () => {
    onToggleLogInModal();
    setIsLogin(false);
  };

  return (
    <>
      <div className={styles.languageButtons}>
        {isLangAvailable && <TranslationDropdown />}
        {!renderMobile && <LoginSignupButtons showModalLogin={showModalLogin} showModalSignUp={showModalSignUp} />}

        {renderMobile && <Menu24 color="#006B8F" onClick={onToggleMobileMenu} />}

        <ModalLogalSignUp display={showLogInModal} isLogin={isLogin} onClose={onToggleLogInModal} />
      </div>

      {showMobileMenu && renderMobile && (
        <ul className={styles.no_logged_mobile_nav} ref={domRef}>
          {routesNav.map((route, index) => (
            <ItemMenu {...route} key={index} />
          ))}

          <div className={styles.mobile_buttons}>
            <LoginSignupButtons showModalLogin={showModalLogin} showModalSignUp={showModalSignUp} />
          </div>
        </ul>
      )}
    </>
  );
};

export default NologgedLanguageButtons;
